'use client';

import { isMvpdAuthenticated } from '../isMvpdAuthenticated';
import { getUserInfo } from './getUserInfo';

/**
 * Checks if the user is authenticated by verifying the presence of an email and access token.
 * This function is intended for client-side use.
 */
export function isUserAuthenticated(): boolean {
  const { accessToken, email } = getUserInfo();

  return Boolean((accessToken && email) || isMvpdAuthenticated(accessToken));
}
